"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatoryResponseStatsResponseSchema = exports.SignatoryResponseStatsRowSchema = exports.SignatoryResponseRangeBucketsSchema = exports.SSTStatisticsStatsSchema = exports.SSTResolutionTimeChartDataPointSchema = exports.SSTApprovalByOfficerChartResponseSchema = exports.SSTApprovalByOfficerDataPointSchema = exports.SSTApprovalBySSTTypeDataPointSchema = exports.SSTApprovalChartDataPointSchema = exports.SSTApprovalGroupBy = void 0;
var zod_1 = require("zod");
// Group by options for SST approval chart
exports.SSTApprovalGroupBy = {
    MEMBER_TYPE: 'memberType',
    SST_TYPE: 'sstType',
    SRB_OFFICER: 'srbOfficer',
};
// Chart data when grouped by member type (Full Member vs Non-Member)
exports.SSTApprovalChartDataPointSchema = zod_1.z.object({
    month: zod_1.z.string(), // YYYY-MM format
    nonMemberCount: zod_1.z.number(),
    fullMemberCount: zod_1.z.number(),
    totalCount: zod_1.z.number(),
});
// Chart data when grouped by SST type (Deck, Engineering, DualRole, Interior)
exports.SSTApprovalBySSTTypeDataPointSchema = zod_1.z.object({
    month: zod_1.z.string(), // YYYY-MM format
    deckCount: zod_1.z.number(),
    engineeringCount: zod_1.z.number(),
    dualRoleCount: zod_1.z.number(),
    interiorCount: zod_1.z.number(),
    totalCount: zod_1.z.number(),
});
// Chart data when grouped by SRB Officer - the set of officers is dynamic (not a fixed enum),
// so each data point carries a map of officer name -> count for that month.
exports.SSTApprovalByOfficerDataPointSchema = zod_1.z.object({
    month: zod_1.z.string(), // YYYY-MM format
    officerCounts: zod_1.z.record(zod_1.z.string(), zod_1.z.number()),
    totalCount: zod_1.z.number(),
});
exports.SSTApprovalByOfficerChartResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.SSTApprovalByOfficerDataPointSchema),
    // Sorted list of every officer name appearing in the range, used to build consistent chart series/colors
    officers: zod_1.z.array(zod_1.z.string()),
});
exports.SSTResolutionTimeChartDataPointSchema = zod_1.z.object({
    month: zod_1.z.string(), // YYYY-MM format
    avgSignatoryDays: zod_1.z.number(), // Time from creation to signatory sign
    avgAdminDays: zod_1.z.number(), // Time from signatory sign to admin edit
    avgSRBOfficerDays: zod_1.z.number(), // Time from admin edit to SRB officer approval
    totalAverageDays: zod_1.z.number(), // Total average resolution days
});
exports.SSTStatisticsStatsSchema = zod_1.z.object({
    totalApproved: zod_1.z.number(),
    // All-time count of totalApproved that were entered directly by an admin (historical sea time),
    // bypassing the signatory/SRB Officer workflow entirely.
    historicalCount: zod_1.z.number(),
    thisMonthCount: zod_1.z.number(),
    // Historical (admin-created) approvals entered this month, called out separately from thisMonthCount
    // since they were not part of the normal signatory/SRB Officer workflow throughput.
    thisMonthHistoricalCount: zod_1.z.number(),
    lastMonthCount: zod_1.z.number(),
    thisMonthPercentageChange: zod_1.z.number(), // Percentage change from last month
    thisMonthAvgResolutionDays: zod_1.z.number(),
    lastMonthAvgResolutionDays: zod_1.z.number(),
    thisMonthAvgResolutionPercentageChange: zod_1.z.number(), // Percentage change from last month
});
exports.SignatoryResponseRangeBucketsSchema = zod_1.z.object({
    under1Day: zod_1.z.number(),
    from1To3Days: zod_1.z.number(),
    from3To7Days: zod_1.z.number(),
    from7To14Days: zod_1.z.number(),
    over14Days: zod_1.z.number(),
});
exports.SignatoryResponseStatsRowSchema = zod_1.z.object({
    signatoryEmail: zod_1.z.string(),
    signatoryName: zod_1.z.string().optional(),
    completedCount: zod_1.z.number(),
    avgDays: zod_1.z.number(),
    minDays: zod_1.z.number(),
    maxDays: zod_1.z.number(),
    rangeBuckets: exports.SignatoryResponseRangeBucketsSchema,
    pendingCount: zod_1.z.number(),
    oldestPendingDays: zod_1.z.number(),
});
exports.SignatoryResponseStatsResponseSchema = zod_1.z.object({
    summary: zod_1.z.object({
        completedCount: zod_1.z.number(),
        rangeBuckets: exports.SignatoryResponseRangeBucketsSchema,
    }),
    rows: zod_1.z.array(exports.SignatoryResponseStatsRowSchema),
});
//# sourceMappingURL=SSTStatistics.js.map